<template>
  <div style="width: 100%;
    height: 100vh;
    background-color: #363636;"></div>
</template>
<script>
import fechaMensalService from "@/domain/fechamentoMensal/FechamentoMensal";
export default {
  props: ["alert"],
  components: {},
  data() {
    return {};
  },
  mounted: function() {
    this.$nextTick(function() {
      this.downloadZip();
    });
  },
  methods: {
    downloadZip() {
      let urlZip = this.$route.query._link;
      this.alert.snackSuccess();
      this.alert.snack.text = "Motor Fiscal está buscando o arquivo";
      this.alert.snack.show = true;
      this.alert.snack.time = 4000;
      this._service = new fechaMensalService(this.$http);
      this._service.fechamentoMensal(urlZip).then(res => {
        if (res.status == 200) {
          var blob = new Blob([this._base64ToArrayBuffer(res.body.doc)], {
            type: "application/zip"
          });
          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display:none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = `FechamentoMensal_${new Date().getTime()}`;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          }
        } else {
          this.alert.snackDanger();
          this.alert.snack.text =
            "Motor Fiscal não conseguiu buscar o arquivo gerado";
          this.alert.snack.show = true;
          this.alert.snack.time = 4000;
        }
      });
    },
    _base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/guestArea/download/fechamentoMensal/Download.vue